'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _modal = _interopRequireDefault(require("./../modal"));

require("whatwg-fetch");

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var DeleteButton = /*#__PURE__*/function (_React$Component) {
  _inherits(DeleteButton, _React$Component);

  function DeleteButton(props) {
    var _this;

    _classCallCheck(this, DeleteButton);

    _this = _possibleConstructorReturn(this, (DeleteButton.__proto__ || Object.getPrototypeOf(DeleteButton)).call(this, props));
    _this.state = {
      deleteConfirmModalOpen: false,
      deletedModalOpen: false,
      deleteFailedModalOpen: false,
      isLoading: false
    };
    _this.closeDeleteConfirmModal = _this.closeDeleteConfirmModal.bind(_assertThisInitialized(_this));
    _this.closeDeletedConfirmModal = _this.closeDeletedConfirmModal.bind(_assertThisInitialized(_this));
    _this.sendDeleteRequest = _this.sendDeleteRequest.bind(_assertThisInitialized(_this));
    _this.openDeleteConfirmModal = _this.openDeleteConfirmModal.bind(_assertThisInitialized(_this));
    _this.closeDeleteFailedModal = _this.closeDeleteFailedModal.bind(_assertThisInitialized(_this));
    _this.renderDeleteConfirmModalContent = _this.renderDeleteConfirmModalContent.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DeleteButton, [{
    key: "sendDeleteRequest",
    value: function sendDeleteRequest(e) {
      var _this2 = this;

      e.preventDefault();
      this.setState({
        isLoading: true
      });
      fetch(this.props.url(this.props.language, this.props.id), {
        credentials: 'include',
        method: 'DELETE'
      }).then(_fetchUtils.default.checkStatus).then(function () {
        _this2.setState({
          deleteConfirmModalOpen: false,
          deletedModalOpen: true,
          isLoading: false
        });
      }).then(function () {
        if (_this2.props.loadData) {
          _this2.props.loadData();
        }
      }).catch(function (err) {
        void 0;

        _this2.setState({
          deleteConfirmModalOpen: false,
          deleteFailedModalOpen: true,
          isLoading: false
        });
      });
    }
  }, {
    key: "closeDeleteConfirmModal",
    value: function closeDeleteConfirmModal(e) {
      e.preventDefault();
      this.setState({
        deleteConfirmModalOpen: false
      });
    }
  }, {
    key: "closeDeletedConfirmModal",
    value: function closeDeletedConfirmModal(e) {
      e.preventDefault();
      this.setState({
        deletedModalOpen: false
      });
    }
  }, {
    key: "closeDeleteFailedModal",
    value: function closeDeleteFailedModal(e) {
      e.preventDefault();
      this.setState({
        deleteFailedModalOpen: false
      });
    }
  }, {
    key: "openDeleteConfirmModal",
    value: function openDeleteConfirmModal(e) {
      e.preventDefault();
      this.setState({
        deleteConfirmModalOpen: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "comp-delete-button"
      }, /*#__PURE__*/_react.default.createElement(_modal.default, {
        id: "delete-record-confirm",
        isOpen: this.state.deleteConfirmModalOpen,
        closeHandler: this.closeDeleteConfirmModal,
        escClose: true,
        backgroundClickClose: true
      }, this.state.isLoading ? this.renderLoading() : this.renderDeleteConfirmModalContent()), /*#__PURE__*/_react.default.createElement(_modal.default, {
        id: "delete-record-confirmed",
        isOpen: this.state.deletedModalOpen,
        closeHandler: this.closeDeletedConfirmModal,
        escClose: false,
        backgroundClickClose: false
      }, /*#__PURE__*/_react.default.createElement("p", null, this.props.labelConfirmed), /*#__PURE__*/_react.default.createElement("div", {
        className: "button-group"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn",
        onClick: function onClick() {
          _this3.setState(function (prev) {
            prev.deleteConfirmModalOpen = false;
            prev.deletedModalOpen = false;
          }, function () {
            return _this3.props.history.push(_this3.props.pathNext1);
          });
        }
      }, this.props.labelNext1), this.props.pathNext2 ? /*#__PURE__*/_react.default.createElement("button", {
        className: "btn",
        onClick: function onClick() {
          return _this3.props.history.push(_this3.props.pathNext2);
        }
      }, this.props.labelNext2) : '')), /*#__PURE__*/_react.default.createElement(_modal.default, {
        id: "delete-record-failed",
        isOpen: this.state.deleteFailedModalOpen,
        closeHandler: this.closeDeleteFailedModal,
        escClose: true,
        backgroundClickClose: true
      }, /*#__PURE__*/_react.default.createElement("p", null, this.props.labelDeleteFailed), /*#__PURE__*/_react.default.createElement("div", {
        className: "button-group"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn",
        onClick: this.closeDeleteFailedModal
      }, this.props.labelCancel))), this.props.asButton ? /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn--small btn--secondary delete-link",
        onClick: this.openDeleteConfirmModal,
        title: this.props.label
      }, this.props.label, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-delete"
      })) : /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn--icon delete-link",
        onClick: this.openDeleteConfirmModal,
        title: this.props.label
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-delete"
      })));
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "datalist__loader"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "loader"
      }));
    }
  }, {
    key: "renderDeleteConfirmModalContent",
    value: function renderDeleteConfirmModalContent() {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
        className: "large space-3"
      }, this.props.labelConfirmation), /*#__PURE__*/_react.default.createElement("div", {
        className: "button-group"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn",
        onClick: this.sendDeleteRequest
      }, this.props.labelConfirmButton), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn--secondary",
        onClick: this.closeDeleteConfirmModal
      }, this.props.labelCancel)));
    }
  }]);

  return DeleteButton;
}(_react.default.Component);

DeleteButton.defaultProps = {
  asButton: false
};
DeleteButton.propTypes = {
  history: _propTypes.default.object.isRequired,
  id: _propTypes.default.number.isRequired,
  url: _propTypes.default.func.isRequired,
  label: _propTypes.default.string.isRequired,
  labelConfirmButton: _propTypes.default.string.isRequired,
  labelCancel: _propTypes.default.string.isRequired,
  labelConfirmation: _propTypes.default.string.isRequired,
  labelSuccess: _propTypes.default.string.isRequired,
  language: _propTypes.default.string.isRequired,
  labelConfirmed: _propTypes.default.string.isRequired,
  labelDeleteFailed: _propTypes.default.string.isRequired,
  pathNext1: _propTypes.default.string.isRequired,
  labelNext1: _propTypes.default.string.isRequired,
  pathNext2: _propTypes.default.string,
  labelNext2: _propTypes.default.string,
  asButton: _propTypes.default.bool,
  loadData: _propTypes.default.func
};
var _default = DeleteButton;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/delete-button/index.js
// module id = 106
// module chunks = 0